import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type InputNames = "tipoBusqueda" | "folioFactura" | "mes" | "anio";

export type Inputs = {
  tipoBusqueda?: string;
  folioFactura?: string;
  mes?: string;
  anio?: number;
};

export type Buttons = "buscar";

const hiddenIfNotFactura = values => values.tipoBusqueda !== "FACTURA";
const hiddenIfFactura = values => values.tipoBusqueda === "FACTURA";

export const formConfig: FormBuilderConfig<InputNames, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: {
        mCol: 4
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Cargos eliminados por periodo",
        data: [
          { value: "FACTURA", label: "Integrantes de membresías existentes" }
        ]
      }
    },
    {
      name: "folioFactura",
      label: "Folio de Factura",
      bts: {
        mCol: 3
      },
      component: ITextBuilder,
      props: {
        uppercase: true,
        hidden: hiddenIfNotFactura
      }
    },
    {
      name: "mes",
      label: "* Mes",
      bts: {
        mCol: 2
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: {
        mCol: 2
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts,
        hidden: hiddenIfFactura
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    folioFactura: {
      requiredIfFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "FACTURA" && !value,
        message: () => "Campo obligatorio"
      }
    },
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "FACTURA" && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["tipoBusqueda", "folioFactura", "mes", "anio", "buscar"]]
};
